<template>
  <div class="Product-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text>
                <v-data-table
                  dense
                  readonly
                  :sort-by="sortBy"
                  sort-desc
                  :mobile-breakpoint="0"
                  :headers="headers"
                  :itemsPerPage="PaymentDetail.length"
                  hide-default-footer
                  :items="PaymentDetail"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">
                        {{ item.createdAt | moment("MM/DD/YYYY") }}
                      </td>
                      <td class="text-left">
                        <span v-if="item.Invoice && item.Invoice.Customer">{{
                          item.Invoice.Customer.name
                        }}</span>
                        <span v-else>N/A</span>
                      </td>
                      <td class="text-right">
                        <span v-if="item.Invoice">{{
                          item.Invoice.localId
                        }}</span>
                        <span v-else>N/A</span>
                      </td>
                      <td class="text-right">
                        {{ item.amount | currency }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import paymentService from "@/modules/Customer/Payment/service.js";

export default {
  props: ["PaymentId"],
  data() {
    return {
      isLoading: true,
      PaymentDetail: [],
      sortBy: "createdAt",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "createdAt",
        },
        {
          text: "Customer",
          align: "left",
          value: "Invoice.Customer.name",
          sortable: true,
        },
        {
          text: "Invoice",
          align: "right",
          value: "Invoice.localId",
          sortable: true,
        },
        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: true,
        },
      ],
    };
  },
  async created() {
    // this.start = this.$route.query.start;
    // this.end = this.$route.query.end;
    await this.getPaymentDetail();
  },
  methods: {
    getPaymentDetail() {
      this.isLoading = true;
      return paymentService.getDetailById(this.PaymentId).then((response) => {
        this.$Progress.finish();
        this.PaymentDetail = response.data;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
